import { Button, Card, Input, SegmentedControl, Select } from "../ui";

const monthValue = ({ year, month }) => (year && month ? `${year}-${String(month).padStart(2, "0")}` : "");

// Step 1 - Store & Period: the store (only those the server lists for the user), the reporting
// month and the analysis type. Applications and files are chosen in step 2.
export default function AnalysisSetup({ text, stores, context, disabled, canContinue, onContext, onNext }) {
  const storeOptions = stores.map((store) => ({ value: store.id, label: `${store.businessName} (${store.id})` }));
  return (
    <section data-testid="step-setup" aria-label={text.flow.setupTitle}>
    <Card className="report-analysis-card report-analysis-step" hoverable={false}>
      <header className="report-analysis-step__head">
        <h3>{text.flow.setupTitle}</h3>
        <p className="report-analysis-muted">{text.flow.setupHint}</p>
      </header>
      <div className="report-analysis-setup">
        <Select
          label={text.store}
          placeholder={text.storePlaceholder}
          options={storeOptions}
          value={context.storeCode}
          onChange={(event) => {
            const store = stores.find((item) => item.id === event.target.value);
            onContext({ storeCode: store?.id || "", storeId: store?._id || "" });
          }}
          disabled={disabled}
          fullWidth
        />
        <Input
          type="month"
          label={text.period}
          value={monthValue(context)}
          fullWidth={false}
          disabled={disabled}
          onChange={(event) => {
            const [year, month] = String(event.target.value || "").split("-");
            onContext({ year: year ? Number(year) : "", month: month ? Number(month) : "" });
          }}
        />
        <SegmentedControl
          label={text.mode}
          options={[{ value: "W", label: text.modes.W }, { value: "M", label: text.modes.M }]}
          value={context.mode}
          onChange={(mode) => onContext({ mode })}
          disabled={disabled}
        />
      </div>
      <div className="report-analysis-actions">
        <Button variant="primary" appearance="filled" onClick={onNext} disabled={!canContinue}>{text.flow.next}</Button>
      </div>
    </Card>
    </section>
  );
}
